<template>
  <div id="app" class="site-shell">
    <header class="site-header">
      <div class="brand">武汉恩米文化传媒有限公司 </div>
      <nav class="site-nav">
        <router-link to="/" exact>首页</router-link>
        <router-link to="/about">关于我们</router-link>
      </nav>
    </header>
    <main class="site-main">
      <router-view />
    </main>
    <footer class="site-footer">
      <span>© 2026 武汉恩米文化传媒有限公司 . All rights reserved.</span>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
